import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

function errorHandle(self, error) {
  return new Promise((resolve, reject) => {
    console.log("エラーハンドリングに入った");
    const errorCode = error.response.data.errors.code;

    switch (errorCode) {
      case 400:
        console.log("400でした");
        resolve();
        break;
      case 401:
        console.log("401でした");
        self.$store
          .dispatch("user/refresh", self)
          .then(() => {
            console.log("リフレッシュ成功");
            resolve();
          })
          .catch(function(error) {
            console.log("リフレッシュ失敗");
            self.$router.push("/");
            console.log(error);
            reject(error);
          });
        break;
      case 404:
        alert("メールアドレス、もしくはパスワードが間違えています。");
        console.log("404でした");
        resolve();
        break;
    }
  });
}

export default { errorHandle };
